import * as GoogleApiConfig from '../config/gapi';
import axios from 'axios';

export default {

  listEvents: (calendarId, start, end, options) => {
    axios.get(`https://content.googleapis.com/calendar/v3/calendars/${calendarId}/events?key=${GoogleApiConfig.apiKey}`)
    .then(res => {
      const items = res.data.items.filter(e => e.status !== 'cancelled');
      const events = items.map(e => {
        
        const start = e.start.date ? new Date(`${e.start.date}T08:00:00`) : new Date(e.start.dateTime)
        const end = e.end.date ? new Date(`${e.start.date}T05:00:00`) : new Date(e.end.dateTime) 

        const isAllDay = e.start.date != null && e.end.date != null;
        
        return {
          title: e.summary,
          start: start,
          end: end,
          description: e.description,
          location: e.location,
          glink: e.htmlLink,
          meta: e,
          allDay: isAllDay
        }
      });
      
      options.success(events);
    });
  }

}


// WEBPACK FOOTER //
// ./src/services/google-calendar.js